import { mapActions } from "vuex";
import StarRating from "vue-star-rating";

export default {
    name: "course-blades-statistic",
    props: {
        item: {
            type: Object,
        },
    },
    components: {
        StarRating,
    },
    computed: {
        totalTimeModule() {
            return this.calculationTimeModule(this.item.duration);
        },
    },
    methods: {
        ...mapActions({
            setLessonFavourite: "coursesLesson/SET_LESSON_FAVOURITE",
            setLessonUnfavourite: "coursesLesson/SET_LESSON_UNFAVOURITE",
            getList: "courses/GET_LIST",
        }),

        formattedTime(time, key = "default") {
            const hours = Math.floor(time / 60);
            const minutes = time % 60;
            if (key === "default") {
                return `${hours < 10 ? "0" + hours : hours} ${this.$t("smHour")} ${
                    minutes < 10 ? "0" + minutes : minutes
                } ${this.$t("smMinutes")}`;
            } else {
                return `${hours < 10 ? "0" + hours : hours}:${
                    minutes < 10 ? "0" + minutes : minutes
                }:00`;
            }
        },
        declensionWord(count) {
            let titles = [
                this.$t("lessonWord1"),
                this.$t("lessonWord2"),
                this.$t("lessonWord3"),
            ];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[
                count % 100 > 4 && count % 100 < 20
                    ? 2
                    : cases[count % 10 < 5 ? count % 10 : 5]
            ];
        },
        calculationTimeModule(duration) {
            const hours = Math.floor(duration / 60);
            const minutes = duration % 60;
            return `${hours} ${this.$t("smHour")}  ${
                minutes < 10 ? "0" + minutes : minutes
            }  ${this.$t("smMinutes")}`;
        },
        async onClickFavorite(item) {
            const storedPin = item.userCourse.data.pin;
            item.userCourse.data.pin = !item.userCourse.data.pin;

            try {
                if (item.userCourse.data.pin) {
                    try {
                        await this.setLessonFavourite({
                            slug: item.slug,
                        });
                    } catch (err) {
                        item.userCourse.data.pin = storedPin;
                        console.log("error");
                        throw err;
                    }
                }

                if (!item.userCourse.data.pin) {
                    try {
                        await this.setLessonUnfavourite({
                            slug: item.slug,
                        });
                    } catch (err) {
                        item.userCourse.data.pin = storedPin;
                        console.log("error");
                        throw err;
                    }
                }
                await this.getList({ isResetList: false, isSkip: true });
            } catch (error) {
                console.error("error[pin]", error);
            }
        },
    },
};
